import React, { useContext } from 'react';
import { useServiceSettings } from './serviceSettings';
import { NoCore, PlannerCoreApi } from '@inter-ikea-storageone/range';
import { PlatsaCoreApi } from '@inter-ikea-storageone/range-platsa';
import { PaxCoreApi } from '@inter-ikea-storageone/range-pax';
import { BestaCoreApi } from '@inter-ikea-storageone/range-besta';
import { EketCoreApi } from '@inter-ikea-storageone/range-eket';
import { SmastadCoreApi } from '@inter-ikea-storageone/range-smastad';
import { IvarCoreApi } from '@inter-ikea-storageone/range-ivar';
import { Range } from 'utils/range';
import { withInsights } from './insights';
import { InsightsApi } from '@insights/insights-data-provider';
import { BillyCoreApi } from '@inter-ikea-storageone/range-billy';
import { BrorCoreApi } from '@inter-ikea-storageone/range-bror';
import { KallaxCoreApi } from '@inter-ikea-storageone/range-kallax';
import { BoaxelCoreApi } from '@inter-ikea-storageone/range-boaxel';
import { LadmakareCoreApi } from '@inter-ikea-storageone/range-ladmakare';
import { JonaxelCoreApi } from '@inter-ikea-storageone/range-jonaxel';
import { ElvarliCoreApi } from '@inter-ikea-storageone/range-elvarli';
import { KnoxhultCoreApi } from '@inter-ikea-storageone/range-knoxhult';
import { AurdalCoreApi } from '@inter-ikea-storageone/range-aurdal';
import reportError from 'error-reporting/reportError';

export const CoreContext = React.createContext<PlannerCoreApi>(new NoCore({} as any, () => {}));

export const useCore = () => useContext(CoreContext);

type Props = {
  children: React.ReactNode;
  insightsApi: InsightsApi;
};

export const initCore = (range: Range, insightsApi: InsightsApi) => {
  if (range === 'pax') {
    return new PaxCoreApi(insightsApi, reportError);
  } else if (range === 'besta') {
    return new BestaCoreApi(insightsApi, reportError);
  } else if (range === 'platsa') {
    return new PlatsaCoreApi(insightsApi, reportError);
  } else if (range === 'eket') {
    return new EketCoreApi(insightsApi, reportError);
  } else if (range === 'smastad') {
    return new SmastadCoreApi(insightsApi, reportError);
  } else if (range === 'ivar') {
    return new IvarCoreApi(insightsApi, reportError);
  } else if (range === 'billy') {
    return new BillyCoreApi(insightsApi, reportError);
  } else if (range === 'bror') {
    return new BrorCoreApi(insightsApi, reportError);
  } else if (range === 'boaxel') {
    return new BoaxelCoreApi(insightsApi, reportError);
  } else if (range === 'kallax') {
    return new KallaxCoreApi(insightsApi, reportError);
  } else if (range === 'ladmakare') {
    return new LadmakareCoreApi(insightsApi, reportError);
  } else if (range === 'jonaxel') {
    return new JonaxelCoreApi(insightsApi, reportError);
  } else if (range === 'elvarli') {
    return new ElvarliCoreApi(insightsApi, reportError);
  } else if (range === 'knoxhult') {
    return new KnoxhultCoreApi(insightsApi, reportError);
  } else if (range === 'aurdal') {
    return new AurdalCoreApi(insightsApi, reportError);
  }
  throw Error('Unknown range');
};

export const CoreProvider = ({ children, insightsApi }: Props) => {
  const { range } = useServiceSettings();
  const coreApi = initCore(range, insightsApi);

  return <CoreContext.Provider value={coreApi}>{children}</CoreContext.Provider>;
};

export const CoreProviderWithInsigths = withInsights(CoreProvider);
